import { render, staticRenderFns } from "./EmptySpace.vue?vue&type=template&id=b834c892&scoped=true&"
import script from "./EmptySpace.vue?vue&type=script&lang=js&"
export * from "./EmptySpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834c892",
  null
  
)

export default component.exports